<script setup lang="ts">
import AppFooter from "~/components/footer/AppFooter.vue";
</script>

<template>
  <div class="flex min-h-screen flex-col bg-white text-slate-800">
    <main class="flex-1">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>
